//import { Observable } from "rxjs/Observable";
import { Observable } from 'rxjs/Rx';
import { Response } from "@angular/http";
import { Injectable } from "@angular/core";


@Injectable()
export class HandleError {
  handleErrorAsObservable(error: any): Observable<any> {
    return Observable.throw(this._handleError(error));
  }

  // TODO manage "unauthorized" extending AuthHttp class
  private _handleError(error: any): String | String[] {
    console.log(error);

    let parsedError: any = null;

    //if (error instanceof Response) {
    console.log("_handleError:Response type");
    try {
      parsedError = error.error;
    }
    catch (ex) {
      console.log(ex);
      console.log('Error response is not a json object.');
    }

    if (parsedError) {
      // Check if the reposnse is a validation result
      let isValidationResult: boolean = false;
      let validationErrors = <any>parsedError;
      let flattenErrors: string[] = [];

      Object.keys(validationErrors || {}).every(key => {
        if (Array.isArray(validationErrors[key])) {
          isValidationResult = true;
          validationErrors[key].forEach(errorMessage => {
            flattenErrors.push(errorMessage);
          });

        }
        else {
          isValidationResult = false;
        }
        return isValidationResult;
      });

      if (isValidationResult && flattenErrors.length)
        return flattenErrors;
      else if (parsedError.title)
        return parsedError.status + ' - ' + parsedError.title;
      else if (parsedError.detail)
        return parsedError.status + ' - ' + parsedError.detail;
      else if (parsedError.message)
        return parsedError.status + ' - ' + parsedError.message;
      else if (parsedError.exception)
        return parsedError.status + ' - ' + parsedError.exception;
    }
    let errMsg = this.getErrorFromResponse(error);
    console.log("_handleError:errMsg", errMsg);
    return errMsg;
  }

  private getErrorFromResponse(error: any): string {
    console.log("HandleError:getErrorFromResponse", error);
    let response = error;//.json();
    console.log("HandleError:getErrorFromResponse#response", response);
    let errMsg = "Lo sentimos, ocurrió un error. Vuelve a intentarlo.";
    if (response.message) {
      errMsg = response.status + ' - ' + response.message;
    }
    if (response.error_description) {
      errMsg = response.status + ' - ' + response.error_description;
    }
    console.log("HandleError:getErrorFromResponse#errMsg", errMsg);
    return errMsg;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/handle-error.ts